import {
  type DateTimeInputProps,
  DateTimeInput as SemanticDateTimeInput,
} from "semantic-ui-calendar-react";

import { formatDate } from "simplydo/core/dates";

import util from "utils/utils";

type InputProps = Omit<DateTimeInputProps, "value" | "minDate" | "maxDate"> & {
  value: Date;
  minDate?: Date;
  maxDate?: Date;
};

const convertLegacyDateFormat = (format: string): string =>
  format
    .replace(/YYYY/g, "yyyy")
    .replace(/YY/g, "yy")
    .replace(/DD/g, "dd")
    .replace(/D/g, "d")
    .replace(/A/g, "aa");

const DateTimeInput = ({
  minDate,
  maxDate,
  value,
  dateTimeFormat = "dd-MM-yyyy HH:mm",
  ...props
}: InputProps) => {
  const normalizedDateTimeFormat = convertLegacyDateFormat(dateTimeFormat);
  // Semantic date input will crash if the current value passed in is outside the range of min and max date
  // This wrapper component will prevent that from happening by intercepting the value prop and setting a new min/max date that fits the current value
  if (value) {
    if (minDate && value < minDate) {
      minDate = value;
    }
    if (maxDate && value > maxDate) {
      maxDate = value;
    }
  }
  return (
    // @ts-ignore
    <SemanticDateTimeInput
      minDate={minDate}
      maxDate={maxDate}
      value={formatDate(value, normalizedDateTimeFormat)}
      dateTimeFormat={normalizedDateTimeFormat}
      {...props}
    />
  );
};

export default DateTimeInput;
